import { gql } from "lib/apolloClient";

/**
 * Phase 1 query: Fetches ONLY grade IDs grouped by school.
 * No names, no counts — minimal payload.
 */
export const getOrganizationGradeIdsHierarchyQuery = gql`
  query getOrganizationGradeIdsHierarchy(
    $organizationId: ID!
    $gradeFilters: GradeFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        grades(filters: $gradeFilters) {
          id
          curriculumProgram {
            id
          }
        }
      }
    }
  }
`;

/**
 * Phase 2 query: Fetches grade name + participant counts for visible grade IDs.
 * Uses multiNode to batch-fetch by IDs.
 * Grades have staffCount/studentCount/familyMemberCount directly — single query for both name and counts.
 */
export const getGradeDetailsByIdsQuery = gql`
  query getGradeDetailsByIds($gradeIds: [ID!]) {
    multiNode(ids: $gradeIds, type: GRADE) {
      id
      ... on Grade {
        id
        name
        staffCount
        studentCount
        familyMemberCount
      }
    }
  }
`;
